import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const { id, currentStatus, steps, segment } = {
  id: null,
  currentStatus: 'new',
  steps: {
    intro: {
      step: 'Giriş Bilgileri',
      email: null,
      phoneNumber: null,
      companyName: null,
      isCompleted: false,
    },
    questions: {
      step: 'Sizi Tanıyalım',
      questions: [],
      isCompleted: false,
    },
    companyInformation: {
      step: 'Firma Bilgileri',
      taxInfo: {
        officialName: null,
        tin: null,
        taxOffice: null,
      },
      webSiteUrl: null,
      addresses: [
        {
          type: 'billing',
          country: {
            code: 'TR',
            title: {
              tr: 'TÜRKİYE',
              en: 'TURKEY',
            },
          },
          city: null,
          county: null,
          district: null,
          zipCode: null,
          street: null,
          geoLocation: {
            latitude: 38.963745,
            longitude: 35.243322,
          },
        },
      ],
      isCompleted: false,
    },
    contactInformation: {
      step: 'İletişim Bilgileri',
      contacts: [
        {
          name: null,
          title: {
            tr: null,
          },
          email: null,
          phone: null,
        },
      ],
      isCompleted: false,
    },
    contract: {
      step: 'Sözleşme',
      contractDocumentUrl: process.env.VUE_APP_SUPPLIER_CONTRACT_URL,
      bankAccounts: [
        {
          primary: true,
          name: null,
          iban: null,
        },
      ],
      contractMedias: [],
      taxMedias: [],
      commercialRegistrationMedias: [],
      chamberRegistrationMedias: [],
      signatureCircularMedias: [],
      isCompleted: false,
    },
  },
  segment: 'starter',
};

export default {
  namespaced: true,
  state: {
    defaultSteps: steps,
    savedApplicationId: localStorage.getItem('savedSupplierApplicationId'),
    id,
    currentStatus,
    segment,
    ...steps,
  },
  actions,
  getters,
  mutations,
};
